import Button from 'components/Form/Button';
import React, { useEffect, useState } from 'react';
import Stocks from '../../../../../../assets/assets/stocks.png';
import { StockShareAllocation } from 'service/dto/beneficiary.dto';
import ConfirmModal from 'components/Modal/ConfirmModal';
import withCreatePortal from 'components/HOC/withCreatePortal';
import { Alert } from 'components/Toast';
import { toast } from 'react-toastify';
import { useUnAssignStockBeneficiary } from 'common/queries-and-mutations/stock-share';

type Props = {
  assets: StockShareAllocation[];
  onSuccess: () => void;
};
const EnhancedConfirmModal = withCreatePortal(ConfirmModal);

export default function StocksBeneficiaryAssets({ assets, onSuccess }: Props) {
  const [showAskToConfirm, setShowAskToConfirm] = useState(false);
  const [selectedAssetId, setSelectedAssetId] = useState<number | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { mutate, isSuccess, isError } = useUnAssignStockBeneficiary();

  const onYesClick = () => {
    setIsSubmitting(true);
    mutate({
      allocationId: selectedAssetId!
    });
  };

  useEffect(() => {
    if (isSuccess && !isError) {
      setShowAskToConfirm(false);
      setSelectedAssetId(null);
      setIsSubmitting(false);
      onSuccess();
      toast(<Alert message="Asset Successfully Removed" type="success" />);
    } else if (isError) {
      setShowAskToConfirm(false);
      setSelectedAssetId(null);
      setIsSubmitting(false);
    }
  }, [isSuccess, isError]);

  return (
    <div>
      {assets?.map(asset => {
        return (
          <div className="mt-2 flex flex-col" key={asset.id}>
            <div className="w-full rounded-md bg-white shadow-sm">
              <div className="border-b border-[#E5E5E5]">
                <div className="flex items-center justify-between p-3 px-5">
                  <span className="text-base font-normal text-[#34475E]">
                    Stocks/Shares
                  </span>
                </div>
              </div>
              <div className="flex flex-wrap items-center justify-between px-4 pb-1">
                <div className="mr-3 space-y-2">
                  <img
                    src={Stocks}
                    className="h-[6.5rem] w-[6.5rem] object-contain"
                  />
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Company Name
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.stock.companyName}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    CSCS Number
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.stock.certificateNo}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Stockbroker Name
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.stock.registerName}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Stockbroker Address
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.stock.registerAddress}
                  </div>
                </div>
                <div className="my-2 mr-3 space-y-2">
                  <div className="text-xs font-medium text-slate-600 ">
                    Percentage Alloted
                  </div>
                  <div className="text-xs text-slate-600 ">
                    {asset.allottedPercentage}
                  </div>
                </div>
                <div className="mr-3 space-y-2">
                  <div className="flex flex-wrap items-center">
                    <Button
                      variant="outline"
                      size="md"
                      className="w-[4rem] place-self-end rounded border border-[#FF6600] bg-[#FF66001A] text-sm text-[#FF6600] lg:ml-8"
                      label="Remove"
                      onClick={() => {
                        setShowAskToConfirm(true);
                        setSelectedAssetId(asset.id);
                      }}
                    ></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {showAskToConfirm && selectedAssetId && (
        <EnhancedConfirmModal
          content="Are you sure you want to remove this asset?"
          onConfirm={onYesClick}
          onCancel={() => {
            setShowAskToConfirm(false);
          }}
          actionText="Yes, Remove"
          cancelText="No"
          title="Action Required"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
}
